import { render, staticRenderFns } from "./VitalAssessedCheck.vue?vue&type=template&id=c27c3b7e&scoped=true&"
import script from "./VitalAssessedCheck.vue?vue&type=script&lang=js&"
export * from "./VitalAssessedCheck.vue?vue&type=script&lang=js&"
import style0 from "./VitalAssessedCheck.vue?vue&type=style&index=0&id=c27c3b7e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c27c3b7e",
  null
  
)

export default component.exports